module.exports = __webpack_public_path__ + "img/tl.fe273366.svg";